module.exports = __webpack_public_path__ + "img/previdencia.08e10556.svg";